export const messages = {
  en: {
    registerProtocol: {
      title: 'Registration Agreement',
      userProtocol: 'User Agreement',
      merchantProtocol: 'Merchant Agreement',
      editorPlaceholder: 'Required, please fill in the content',
      fetchError: 'Failed to fetch registration agreement'
    }
  },
  zh: {
    registerProtocol: {
      title: '注册协议',
      userProtocol: '用户协议',
      merchantProtocol: '隐私政策',
      editorPlaceholder: '必填，请填写内容',
      fetchError: '获取注册协议失败'
    }
  }
}